import { render, staticRenderFns } from "./UpdloadWechatFile.vue?vue&type=template&id=672d3d1f&"
import script from "./UpdloadWechatFile.vue?vue&type=script&lang=js&"
export * from "./UpdloadWechatFile.vue?vue&type=script&lang=js&"
import style0 from "./UpdloadWechatFile.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports